export const state = {
    type: null,
    message: null,
    alerts: {
        success: [],
        error: [],
        warning: [],
        info: []
    }
};

export const mutations = {
    success(state, message) {
        state.type = 'success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    },
    // New mutations for global alerts system
    ADD_ALERT(state, { type, message, id = null }) {
        const alertId = id || (Date.now() + Math.random());
        const alert = { id: alertId, message, timestamp: Date.now() };
        
        if (state.alerts[type]) {
            state.alerts[type].push(alert);
        }
        
        return alertId;
    },
    REMOVE_ALERT(state, { type, id }) {
        if (state.alerts[type]) {
            const index = state.alerts[type].findIndex(alert => alert.id === id);
            if (index > -1) {
                state.alerts[type].splice(index, 1);
            }
        }
    },
    CLEAR_ALERTS(state, type = null) {
        if (type && state.alerts[type]) {
            state.alerts[type] = [];
        } else {
            // Clear all alerts
            Object.keys(state.alerts).forEach(key => {
                state.alerts[key] = [];
            });
        }
    }
};

export const getters = {
    getAlertsByType: (state) => (type) => {
        return state.alerts[type] || [];
    },
    getAllAlerts: (state) => {
        return state.alerts;
    },
    hasAlerts: (state) => {
        return Object.values(state.alerts).some(alerts => alerts.length > 0);
    }
};

export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    },
    // New actions for global alerts system
    showAlert({ commit }, { type, message, duration = 5000 }) {
        const alertId = Date.now() + Math.random();
        commit('ADD_ALERT', { type, message, id: alertId });
        
        // Auto-remove alert after duration
        if (duration > 0) {
            setTimeout(() => {
                commit('REMOVE_ALERT', { type, id: alertId });
            }, duration);
        }
        
        return alertId;
    },
    showSuccess({ dispatch }, message) {
        return dispatch('showAlert', { type: 'success', message, duration: 5000 });
    },
    showError({ dispatch }, message) {
        return dispatch('showAlert', { type: 'error', message, duration: 8000 });
    },
    showWarning({ dispatch }, message) {
        return dispatch('showAlert', { type: 'warning', message, duration: 6000 });
    },
    showInfo({ dispatch }, message) {
        return dispatch('showAlert', { type: 'info', message, duration: 5000 });
    },
    removeAlert({ commit }, { type, id }) {
        commit('REMOVE_ALERT', { type, id });
    },
    clearAlerts({ commit }, type = null) {
        commit('CLEAR_ALERTS', type);
    }
};
